import * as React from 'react';
import logoLight from '@/assets/images/svg/logo_var_two.svg';

interface ShareCardProps {
  /** The quoted message text shown on the card. */
  text: string;
  /** Echo name shown in the footer attribution. */
  echoName: string;
}

/**
 * Off-screen branded share card (320x320) for html-to-image capture.
 * Matches the mobile app's ShareCard design exactly.
 * Uses inline styles — html-to-image captures computed CSS, so Tailwind classes
 * are unreliable in the off-screen capture context.
 */
export const ShareCard = React.forwardRef<HTMLDivElement, ShareCardProps>(
  ({ text, echoName }, ref) => (
    <div
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        pointerEvents: 'none',
      }}
      aria-hidden='true'
    >
      <div
        ref={ref}
        style={{
          width: 320,
          height: 320,
          borderRadius: 16,
          overflow: 'hidden',
          background: 'linear-gradient(180deg, #1A1036 0%, #2C1470 100%)',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          fontFamily: "'Inter', 'Inter var', sans-serif",
        }}
      >
        <img
          src={logoLight}
          alt=''
          style={{ width: 80, height: 28, objectFit: 'contain' }}
          crossOrigin='anonymous'
        />

        <p
          style={{
            fontSize: 16,
            lineHeight: '24px',
            fontWeight: 500,
            color: '#FFFFFF',
            fontStyle: 'italic',
            margin: 0,
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 6,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {'\u201C'}
          {text}
          {'\u201D'}
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 4,
          }}
        >
          <span
            style={{
              fontFamily: "'Proxima Nova', sans-serif",
              fontSize: 14,
              fontWeight: 700,
              color: '#BFB0F8',
            }}
          >
            — {echoName}
          </span>
          <span
            style={{
              fontSize: 12,
              fontWeight: 400,
              color: '#BFB0F880',
            }}
          >
            dechoes.com
          </span>
        </div>
      </div>
    </div>
  )
);

ShareCard.displayName = 'ShareCard';
